import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { IconType } from '@factorialco/f0-react'
import { useAiChat } from '@factorialco/f0-react/dist/experimental'

interface UseAiChatAgentParams {
  agent: string
  initialMessage?: string
  welcomeScreenSuggestions?: {
    icon: IconType
    message: string
  }[]
  moduleBasePath: string
}

export const useAiChatAgent = ({
  agent: targetAgent,
  initialMessage,
  welcomeScreenSuggestions,
  moduleBasePath,
}: UseAiChatAgentParams) => {
  const {
    tmp_setAgent,
    setInitialMessage,
    agent,
    clear,
    setWelcomeScreenSuggestions,
    setAutoClearMinutes,
  } = useAiChat()

  const location = useLocation()

  // Setup agent on mount
  useEffect(() => {
    if (agent !== targetAgent) {
      tmp_setAgent(targetAgent)
      setInitialMessage(initialMessage)
      clear()
      setAutoClearMinutes(60 * 24) // 24 hours
      if (welcomeScreenSuggestions) {
        setWelcomeScreenSuggestions(welcomeScreenSuggestions)
      }
    }

    return () => {
      const isLeavingModule = !location.pathname.startsWith(moduleBasePath)
      if (isLeavingModule) {
        tmp_setAgent('one-workflow')
        requestAnimationFrame(() => {
          clear()
        })
        setInitialMessage(undefined)
      }
    }
  }, [])
}
